import { TOGGLE_DAYS_FILTER_MENU } from './constants';

export function toggleDaysFilterMenu(value) {
  return {
    type: TOGGLE_DAYS_FILTER_MENU,
    value,
  };
}
